import BottomNavigation from "@mui/material/BottomNavigation";
import BottomNavigationAction from "@mui/material/BottomNavigationAction";
import { Link, withRouter } from "react-router-dom";
import {
  BottomNavAboutIcon,
  BottomNavContactIcon,
  BottomNavFaqIcon,
  BottomNavHomeIcon,
  BottomNavSimulationIcon,
} from "../Icons";

const BottomNavBar = ({
  bottomNavState,
  handleBottomNavStateChange,
  location,
}) => {
  const selectedColor = "#017aff";
  const defaultColor = "#8e8e93";
  const value = bottomNavState.pathMap.indexOf(location.pathname);

  return (
    <>
      <BottomNavigation
        value={value}
        onChange={handleBottomNavStateChange}
        showLabels
        sx={{
          display: { lg: "none" },
          width: "100%",
          position: "fixed",
          bottom: 0,
          zIndex: 99,
          boxShadow: "0 -4px 9px -7px #333",
        }}
      >
        <BottomNavigationAction
          label="Home"
          icon={
            <BottomNavHomeIcon
              fillColor={value === 0 ? selectedColor : defaultColor}
            />
          }
          component={Link}
          to="/"
        />
        <BottomNavigationAction
          label="Simulation"
          icon={
            <BottomNavSimulationIcon
              fillColor={value === 1 ? selectedColor : defaultColor}
            />
          }
          component={Link}
          to="/simulation"
        />
        <BottomNavigationAction
          label="About"
          icon={
            <BottomNavAboutIcon
              fillColor={
                bottomNavState.value === 2 ? selectedColor : defaultColor
              }
            />
          }
          component={Link}
          to="/about"
        />
        <BottomNavigationAction
          label="FAQ"
          icon={
            <BottomNavFaqIcon
              fillColor={
                bottomNavState.value === 3 ? selectedColor : defaultColor
              }
            />
          }
          component={Link}
          to="/faq"
        />
        <BottomNavigationAction
          label="Contact"
          icon={
            <BottomNavContactIcon
              fillColor={
                bottomNavState.value === 4 ? selectedColor : defaultColor
              }
            />
          }
          component={Link}
          to="/contact"
        />
      </BottomNavigation>
    </>
  );
};

export default withRouter(BottomNavBar);
